// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__Qzn6Z","range":"MonthRangeSwitch_range__2Hp0K","disabled":"MonthRangeSwitch_disabled__1Y9YQ"};